import React from "react";

const INLINE_NO_BREAK_SEGMENT_PATTERN = /((?:préparation du Dispatch|recalcul en cours|paramètres chauffeur et camion|Dispatch(?: (?:Jour|Soir))?…?|[\p{L}\p{N}]+(?:-[\p{L}\p{N}]+)+))/giu;

function wrapNoBreakSegment(part, key) {
  return React.createElement(
    "span",
    { className: "whitespace-nowrap", key },
    part,
  );
}

export function renderInlineNoBreakIdentifiers(message) {
  if (typeof message !== "string") {
    return message;
  }

  const parts = message.split(INLINE_NO_BREAK_SEGMENT_PATTERN);
  if (parts.length === 1) {
    return message;
  }

  return parts.map((part, index) => {
    if (!part) {
      return null;
    }

    if (index % 2 === 1) {
      return wrapNoBreakSegment(part, `inline-no-break-${index}`);
    }

    return part;
  });
}
